// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.model-status .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24.MuiDialog-paper.MuiDialog-paperScrollPaper.MuiDialog-paperWidthSm.css-1t1j96h-MuiPaper-root-MuiDialog-paper{
    min-width: 450px !important;
    padding: 20px !important
}
.file-upload-form .filelabel {
    width: 100%;
    border: 2px dashed grey;
    border-radius: 5px;
    display: block;
    padding: 5px;
    transition: border 300ms ease;
    cursor: pointer;
    text-align: center;
    margin: 0;
}
.file-upload-form .filelabel i {
    display: block;
    font-size: 30px;
    padding-bottom: 5px;
}
.file-upload-form .filelabel i,
.file-upload-form .filelabel .title {
  color: grey;
  transition: 200ms color;
}
.file-upload-form .filelabel:hover {
  border: 2px solid #1665c4;
}
.file-upload-form .filelabel:hover i,
.file-upload-form .filelabel:hover .title {
  color: #1665c4;
}
.file-upload-form #FileInput{
    display:none;
}`, "",{"version":3,"sources":["webpack://./src/components/requestTracking/modelStatus.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B;AACJ;AACA;IACI,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;AACA;;EAEE,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,cAAc;AAChB;AACA;IACI,YAAY;AAChB","sourcesContent":[".model-status .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24.MuiDialog-paper.MuiDialog-paperScrollPaper.MuiDialog-paperWidthSm.css-1t1j96h-MuiPaper-root-MuiDialog-paper{\r\n    min-width: 450px !important;\r\n    padding: 20px !important\r\n}\r\n.file-upload-form .filelabel {\r\n    width: 100%;\r\n    border: 2px dashed grey;\r\n    border-radius: 5px;\r\n    display: block;\r\n    padding: 5px;\r\n    transition: border 300ms ease;\r\n    cursor: pointer;\r\n    text-align: center;\r\n    margin: 0;\r\n}\r\n.file-upload-form .filelabel i {\r\n    display: block;\r\n    font-size: 30px;\r\n    padding-bottom: 5px;\r\n}\r\n.file-upload-form .filelabel i,\r\n.file-upload-form .filelabel .title {\r\n  color: grey;\r\n  transition: 200ms color;\r\n}\r\n.file-upload-form .filelabel:hover {\r\n  border: 2px solid #1665c4;\r\n}\r\n.file-upload-form .filelabel:hover i,\r\n.file-upload-form .filelabel:hover .title {\r\n  color: #1665c4;\r\n}\r\n.file-upload-form #FileInput{\r\n    display:none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
